import React from 'react';
import styles from './BadgePillGroup.module.scss';
import BadgePill from '../badge-pill';
import BadgeDropdown, { BadgeDropdownItem } from '../badge-dropdown';

export type BadgePillItem = {
  id: string;
  label: string;
};

type BadgePillGroupProps = {
  items: BadgePillItem[];
  maxVisible?: number;
  className?: string;
};

const BadgePillGroup: React.FC<BadgePillGroupProps> = ({
  items,
  maxVisible = 3,
  className = ''
}) => {
  if (!items || items.length === 0) {
    return null;
  }

  const visibleItems = items.slice(0, maxVisible);
  const hiddenItems = items.length > maxVisible ? items.slice(maxVisible) : [];
  
  // Convert hidden items to dropdown items
  const dropdownItems: BadgeDropdownItem[] = hiddenItems.map(item => ({
    id: item.id,
    label: item.label
  }));

  return (
    <div className={`${styles.badgePillGroup} ${className}`}>
      {visibleItems.map(item => (
        <BadgePill key={item.id} label={item.label} />
      ))}
      
      {hiddenItems.length > 0 && (
        <BadgeDropdown
          trigger={<BadgePill label="..." isEllipsis />}
          items={dropdownItems}
        />
      )}
    </div>
  );
};

export default BadgePillGroup;
